export default function DemoVideo() {
  return (
    <div className="py-10">
      <div className="mx-auto aspect-video w-full max-w-2xl">
        <iframe
          className="h-full w-full"
          src="https://www.youtube.com/embed/5xjsfjqOSGI?si=bjlGPKcVxSCgF-fp"
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    </div>
  )
}
